import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const LOGIN_URL =
  'https://us-west-1zbcebsp5u.auth.us-west-1.amazoncognito.com/login?client_id=7pnbgv82lii06tdqehimv0todu&response_type=token&scope=email+openid+phone+profile&&redirect_uri=https://snnsymposium.com';

export const OptionsWrapper = ({ options, isMenuOpen, closeMenu }) => {
  return (
    <>
      {/* Desktop nav (hidden on mobile via CSS) */}
      <div className="snn-desktop-nav">
        {options.map((o) => (
          <Link key={o.label} to={o.link} className="snn-desktop-nav-item">
            {o.label}
          </Link>
        ))}
        <a href={LOGIN_URL} className="snn-desktop-nav-item login">
          Login / Register
        </a>
      </div>

      {/* Mobile drawer (hidden on desktop via CSS) */}
      <div className={`snn-mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="snn-mobile-menu-list">
          {options.map((o) => (
            <Link
              key={o.label}
              to={o.link}
              className="snn-mobile-menu-item"
              onClick={closeMenu}
            >
              {o.label}
            </Link>
          ))}
          <a href={LOGIN_URL} className="snn-mobile-menu-item login" onClick={closeMenu}>
            Login / Register
          </a>
        </div>
      </div>
    </>
  );
};

OptionsWrapper.propTypes = {
  options: PropTypes.array.isRequired,
  isMenuOpen: PropTypes.bool,
  closeMenu: PropTypes.func,
};

OptionsWrapper.defaultProps = {
  isMenuOpen: false,
  closeMenu: () => {},
};
